import { Company } from './company.model';

export class User {
  id!: number;
  first_name!: string;
  last_name!: string;
  email!: string;
  company!: Company;
  phone?: string;
  password?: string;
  admin?: boolean;
  super_manager?: boolean;
  anonym?: boolean;
  corporate?: boolean;
  corporateStatus?: string;
  corporateData?: CorporateData;
  permission?: unknown;
  restaurantManager?: boolean;
}

export class CorporateData {
  name?: string;
  number?: string;
  address?: string;
  email?: string;
  phone?: string;
}

export class CustomerOrderItem {
  id!: number;
  name!: string;
  variations!: { id: number; name: string }[];
  addons!: { id: number; name: string }[];
  comment!: string;
}

export class CustomerOrder {
  id!: number;
  status!: string;
  restaurantName!: string;
  createdAt!: string;
  paidAt!: string;
  closedAt!: string;
  totalPrice!: number;
  vat!: number;
  items!: CustomerOrderItem[];
  direction!: string;
  comment!: string;
}

export const USER_ROLE_SUPERADMIN = 'SUPERADMIN';
export const USER_ROLE_ADMIN = 'ADMIN';
export const USER_ROLE_RESTAURANT_MANAGER = 'RESTAURANT_MANAGER';
